import BaseApiService from "./BaseApiService";

const journalListing = (phone, page, pageSize) => {
  return BaseApiService.get(
    `/api/v1/journal/entries/${phone}?page=${page}&pagesize=${pageSize}`,
    null,
    null
  );
};

const journalUpdate = (journalId, payload) => {
  return BaseApiService.patch(`/api/v1/journal/entries/${journalId}`, null, payload);
};

const journalDelete = (journalId) => {
  return BaseApiService.delete(`/api/v1/journal/entries/${journalId}`, null, null);
};

const journalSequenctCreate=(payload)=>{
  return BaseApiService.post(`/api/v1/journal/sequence`, null, payload);
}

const journalSequenctUpdate = (sequenceId,payload)=>{
  return BaseApiService.patch(`/api/v1/journal/sequence/${sequenceId}`, null, payload);
}


export const JournalAPIService = {
  journalListing,
  journalUpdate,
  journalDelete,
  journalSequenctCreate,
  journalSequenctUpdate

};
